module.exports = __webpack_public_path__ + "static/katherine-volkovski-Q_MJjEN14uk-unsplash-713f8062ae6a88561cc53bddfcbe5d93.jpg";